module.exports = __webpack_public_path__ + "img/7-3@2x.073f3f8f.png";